/**
 * @file
 * Behaviors for the Hero Slider.
 */
/* global Vimeo */

!(($, Drupal) => {
  'use strict';

  /**
   * Setup and attach the Hero Slider.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.heroSlider = {
    attach(context, drupalSettings) {
      const $heroSlider = $('.hero-slider', context);
      if (!$heroSlider.length) {
        return;
      }

      $heroSlider.each((i, slide) => {
        let autoplay = false;
        let autoplaySpeed = null;
        if (drupalSettings.slider.interval && drupalSettings.slider.interval.length && (parseInt(drupalSettings.slider.interval) !== 0)) {
          autoplay = true;
          autoplaySpeed = parseInt(drupalSettings.slider.interval);
        }

        const $slider = $('.hero-slider__slide-wrapper', $(slide));
        if ($slider.find('.hero-slider__slide').length > 1) {
          $slider.slick({
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            arrows: false,
            appendDots: $slider.siblings('.hero-slider__dots'),
            dots: true,
          });
        }
      });
    }
  };
})(jQuery, Drupal);
